module.exports = __webpack_public_path__ + "img/03_sp.e68637c8.jpg";